import styled from '@emotion/styled';
import { brandNeutralColors, colors } from '@anyroad/theme';

export const QuestionsContainer = styled.div`
  width: 100%;
`;

export const QuestionItem = styled.div<{
  isFirst: boolean;
  isLast: boolean;
  hasBottomBorder: boolean;
}>`
  padding: 24px 0;
  ${(props) =>
    (!props.isLast || props.hasBottomBorder) &&
    `border-bottom: 1px solid ${brandNeutralColors.border};`}
`;

export const QuestionLabel = styled.label`
  display: block;
  font-size: 16px;
  font-weight: 500;
  color: ${colors.text.primary};
  margin-bottom: 8px;
  line-height: 1.4;
`;

export const QuestionSubtitle = styled.div`
  font-size: 14px;
  color: ${colors.text.secondary};
  margin-bottom: 12px;
  line-height: 1.4;
`;

export const QuestionSubtext = styled.div`
  font-size: 13px;
  color: ${colors.text.secondary};
  margin-top: 8px;
  line-height: 1.4;
`;

export const InputWrapper = styled.div`
  width: 100%;
`;
